import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const clothIssueEntry = createAsyncThunk('clothIssueEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=InsertClothIssue`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const cuttingReturnEntry = createAsyncThunk('cuttingReturnEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertInhouseCuttingReturn`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMasterMlist = createAsyncThunk('fetchMasterMlist', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCuttingMasterlistManually`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCuttingList = createAsyncThunk('fetchCuttingList', async (id) => {
    try {
        const endpoint = id ? `getCuttinglist&cutId=${id}` : 'getCuttinglist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCuttingMemoWise = createAsyncThunk('fetchCuttingMemoWise', async (id) => {
    try {
        // const endpoint = id ? `getCuttinglist&ctMemo=${id}` : 'getCuttinglist';
        const response = await axios.get(`${baseUrl}?apicall=getCuttinglist&ctMemo=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchContractorMemo = createAsyncThunk('fetchContractorMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getContractorMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCutReturnMemo = createAsyncThunk('fetchCutReturnMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCuttingReturnMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchContractorReturnMemo = createAsyncThunk('fetchContractorReturnMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getContractorReturnMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAllCutReturnInhosuelist = createAsyncThunk('fetchAllCutReturnInhosuelist', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=getAllCtReturnInhouselist&ctId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAllCutReturnContractor = createAsyncThunk('fetchAllCutReturnContractor', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=getAllCtReturnContractorlist&cutId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCuttingReturnlist = createAsyncThunk('fetchCuttingReturnlist', async (id) => {
    try {
        const endpoint = id ? `getCuttingReturnInhouselist&ctreMemo=${id}` : 'getCuttingReturnInhouselist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCuttingReturnlist2 = createAsyncThunk('fetchCuttingReturnlist2', async (id) => {
    try {
        const endpoint = id ? `getCuttingReturnInhouselist&ctId=${id}` : 'getCuttingReturnInhouselist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchContractorReturnlist = createAsyncThunk('fetchContractorReturnlist', async (id) => {
    try {
        const endpoint = id ? `getCuttingReturnContractorlist&reId=${id}` : 'getCuttingReturnContractorlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchContractorReGrplist2 = createAsyncThunk('fetchContractorReGrplist2', async (id) => {
    try {
        const endpoint = id ? `getCuttingReturnContractorlist&cutId=${id}` : 'getCuttingReturnContractorlist';

        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteSingleCutting = createAsyncThunk('deleteSingleCutting', async ({ id, cIssId }) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteCuttingEntry&cutId=${id}&cIssId=${cIssId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteCuttingReturn = createAsyncThunk('deleteCuttingReturn', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteCuttingReturnReg&ctId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const cuttingApiSlice = createSlice({
    name: 'CuttingDatalist',
    initialState: {
        isLoading: false,
        masterMlist: null,
        cuttinglist: null,
        contMemo: null,
        contRememo: null,
        cutReturn: null,
        contReturn: null,
        deleteReturn: null,
        allInReturn: null,
        allContReturn: null,
        cutReGrp: null,
        ctReMemo: null,
        delreId: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMasterMlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMasterMlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.masterMlist = action.payload;
        });
        builder.addCase(fetchMasterMlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCuttingList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCuttingList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cuttinglist = action.payload;
        });
        builder.addCase(fetchCuttingList.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchContractorMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchContractorMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contMemo = action.payload;
        });
        builder.addCase(fetchContractorMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchContractorReturnMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchContractorReturnMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contRememo = action.payload;
        });
        builder.addCase(fetchContractorReturnMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCuttingReturnlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCuttingReturnlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cutReturn = action.payload;
        });
        builder.addCase(fetchCuttingReturnlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCuttingReturnlist2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCuttingReturnlist2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cutReturn = action.payload;
        });
        builder.addCase(fetchCuttingReturnlist2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchContractorReturnlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchContractorReturnlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contReturn = action.payload;
        });
        builder.addCase(fetchContractorReturnlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleCutting.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleCutting.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteReturn = action.payload;
        });
        builder.addCase(deleteSingleCutting.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchAllCutReturnInhosuelist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAllCutReturnInhosuelist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allInReturn = action.payload;
        });
        builder.addCase(fetchAllCutReturnInhosuelist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchAllCutReturnContractor.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAllCutReturnContractor.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allContReturn = action.payload;
        });
        builder.addCase(fetchAllCutReturnContractor.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchContractorReGrplist2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchContractorReGrplist2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cutReGrp = action.payload;
        });
        builder.addCase(fetchContractorReGrplist2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteCuttingReturn.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteCuttingReturn.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delreId = action.payload;
        });
        builder.addCase(deleteCuttingReturn.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCutReturnMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCutReturnMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ctReMemo = action.payload;
        });
        builder.addCase(fetchCutReturnMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchCuttingMemoWise.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCuttingMemoWise.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cuttinglist = action.payload;
        });
        builder.addCase(fetchCuttingMemoWise.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default cuttingApiSlice.reducer;
